import { render, staticRenderFns } from "./gencp.vue?vue&type=template&id=43ec0d94&scoped=true"
import script from "./gencp.vue?vue&type=script&lang=js"
export * from "./gencp.vue?vue&type=script&lang=js"
import style0 from "./gencp.vue?vue&type=style&index=0&id=43ec0d94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec0d94",
  null
  
)

/* custom blocks */
import block0 from "./gencp.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports